'use client';

import { useState } from 'react';

import { OnBoardingStartForm } from '@/features/OnBoardingModal';
import { useStartNewsProfile } from '@/entities/profile';

interface OnBoardingStartProps {
  username: string;
  onNextStep: () => void;
}

const OnBoardingStart = ({ username, onNextStep }: OnBoardingStartProps) => {
  const [isChecked, setIsChecked] = useState(false);
  const [isError, setIsError] = useState(false);
  const { mutate } = useStartNewsProfile();

  const handleChecked = () => {
    setIsError(false);
    setIsChecked(!isChecked);
  };

  const handleNextStep = () => {
    if (isChecked) {
      mutate();
      onNextStep();
    } else setIsError(true);
  };

  return (
    <OnBoardingStartForm
      username={username}
      isChecked={isChecked}
      isError={isError}
      onChange={handleChecked}
      onNextStep={handleNextStep}
    />
  );
};

export default OnBoardingStart;
